<template>
        <img :src="data.img" />
</template>

<script>
import ModuleSection from './ModuleSection.vue'

export default {
    components: {
        ModuleSection
    },
    props: {
        data: {
            type: Object,
            require: true
        },
    }
}
</script>

<style lang="scss" scoped>
img {
    width: 1500px;
    margin: 0 auto;
}
</style>
